import { render, staticRenderFns } from "./PrfTraceabilityView.vue?vue&type=template&id=2a41b63e"
import script from "./PrfTraceabilityView.vue?vue&type=script&lang=js"
export * from "./PrfTraceabilityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports